var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m10,37.5c0-15.19,12.31-27.5,27.5-27.5,9.18,0,17.3,4.5,22.3,11.4,1.64,2.26,2.94,4.78,3.83,7.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.34 23.85 51.64 21.48 63.3 27.91 68.86 15.81 71.32 16.95 64.54 31.68 50.34 23.85"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m65,37.5c0,15.19-12.31,27.5-27.5,27.5-12.18,0-22.51-7.92-26.13-18.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.66 51.15 23.36 53.52 11.7 47.09 6.14 59.19 3.68 58.05 10.46 43.32 24.66 51.15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/__Refresh.908b88b98dbe781c76bd91caee013c04.svg";
export { ForwardRef as ReactComponent };